var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#phone_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.805 8.902a8.8 8.8 0 0 0 3.293 3.293l.737-1.032a.833.833 0 0 1 1.078-.246 9.5 9.5 0 0 0 3.82 1.136.834.834 0 0 1 .767.831v3.718a.834.834 0 0 1-.748.83q-.663.069-1.335.068C8.283 17.5 2.5 11.717 2.5 4.583q0-.672.068-1.335a.833.833 0 0 1 .83-.748h3.718a.833.833 0 0 1 .83.768 9.5 9.5 0 0 0 1.137 3.819.833.833 0 0 1-.246 1.078zm-2.102-.548 1.584-1.13c-.45-.97-.758-2-.915-3.057H4.176q-.007.207-.007.416c-.001 6.214 5.035 11.25 11.249 11.25q.209 0 .416-.008v-2.197a11.2 11.2 0 0 1-3.056-.915l-1.131 1.584a10 10 0 0 1-1.324-.625l-.048-.028a10.46 10.46 0 0 1-3.918-3.918l-.028-.049a10 10 0 0 1-.625-1.323"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "phone_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgPhone;